import { render } from "./GiftAssign.vue?vue&type=template&id=6e5bcf52"
import script from "./GiftAssign.vue?vue&type=script&lang=js"
export * from "./GiftAssign.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__